import { getSession } from "next-auth/react";

import { PlainLayout } from "@/layouts/PlainLayout";
import { LoginPage } from "@/modules/auth/pages/LoginPage";

const LoginPageRoute = () => {
  return <LoginPage />;
};

LoginPageRoute.getLayout = (page) => <PlainLayout>{page}</PlainLayout>;

export default LoginPageRoute;

export const getServerSideProps = async (context) => {
  const session = await getSession({ req: context.req });

  if (!!session) {
    // Already logged in!
    return { redirect: { destination: "/", permanent: false } };
  }

  return { props: {} };
};
